/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".eventFullscreen[_nghost-%COMP%]   *[_ngcontent-%COMP%], .eventFullscreen   [_nghost-%COMP%]   *[_ngcontent-%COMP%]{display:none!important}[_nghost-%COMP%]{padding-left:1.5rem;padding-bottom:1.5rem;display:flex;align-items:center}.nav-item[_ngcontent-%COMP%]{width:100%;padding:.5rem;display:flex;color:#fff;font-size:1.2rem}.nav-item[_ngcontent-%COMP%]:focus{text-decoration:none}"];
export { styles as styles };

